import { PagedResult } from "$src/domain/core/PagedResult";
import type { ISearchRepository } from "$src/domain/searches/ISearchRepository";
import { ISearchService } from "$src/domain/searches/ISearchService";
import { SearchResult } from "$src/domain/searches/SearchResult";
import { inject, injectable } from "tsyringe";

@injectable()
export class SearchService implements ISearchService {

    private searchRepository: ISearchRepository;

    constructor(@inject("ISearchRepository") searchRepository: ISearchRepository) {
        this.searchRepository = searchRepository;
    }

    async search(groupStoreId: string, query: string, pageNumber: number, pageSize: number): Promise<PagedResult<SearchResult>> {
        return await this.searchRepository.search(groupStoreId, query, pageNumber, pageSize);
    }
}